import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({ selector: '[appInputToNumber]' })
export class InputToNumberDirective {

  constructor(private el: ElementRef, private ngControl: NgControl) {
  }

  @HostListener('blur')
  public onInputBlur(): void {
    const value: any = this.el.nativeElement.value;
    let parsedValue: number = parseFloat(value);

    if (isNaN(parsedValue)) {
      parsedValue = null;
    }

    this.ngControl.control.setValue(parsedValue);
  }

}
